import { FETCH_ROLES_FULFILLED } from './actions';

import type { Role } from '@/types/rules';

export interface RolesAction {
  type: string;
  payload?: Role[];
}

const rolesReducer = (state: Role[] = [], action: RolesAction): Role[] => {
  if (action.type === FETCH_ROLES_FULFILLED) {
    return action.payload ?? [];
  } else {
    return state;
  }
};

export { rolesReducer };
